import { useQuery } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";

import { type Cooperative, type CooperativeRawResponse } from "./cooperative.types";
import { CooperativeQueryKeys } from "./cooperativeQueryKeys";

type getAllCooperativesResponse = Cooperative[];

export const getAllCooperatives = async (): Promise<getAllCooperativesResponse> => {
  const response = await axiosInstanceNamek.get<CooperativeRawResponse[]>(`v1/Cooperatives`);
  return response.data.map((c) => ({
    id: c.id,
    name: c.name,
  }));
};

export const useCooperatives = () => {
  return useQuery({
    queryKey: ["Cooperativas", CooperativeQueryKeys.GET_ALL],
    queryFn: getAllCooperatives,
    staleTime: Infinity, // cachea indefinidamente en la sesión
  });
};
